// extracted by mini-css-extract-plugin
var _1 = "GXcFbpSxGHulWLqR0Nm2";
var _2 = "GXcFbpSxGHulWLqR0Nm2";
var _3 = "pyNXRFHs2RwF8WgVW4zT";
var _4 = "t1ry5ffDuB0pJgWT8_1A";
var _5 = "t1ry5ffDuB0pJgWT8_1A";
var _6 = "jThVZiQeqJ8T57LH4crm";
var _7 = "jThVZiQeqJ8T57LH4crm";
var _8 = "sy88Cx54npa5RD84i1B4";
var _9 = "sy88Cx54npa5RD84i1B4";
export { _1 as "fixed-width-is-active", _2 as "fixedWidthIsActive", _3 as "heading", _4 as "inline-block", _5 as "inlineBlock", _6 as "small-checkbox", _7 as "smallCheckbox", _8 as "text-right", _9 as "textRight" }
